import { Modal } from 'rsuite';
import React, { useEffect, useId, useState } from 'react';
import debounce from 'lodash.debounce';
import { BREAKPOINT_ENUM } from '../common/enums';

const ResponsiveModal = ({ isOpen, onClose, children, ariaLabel = ""}) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= BREAKPOINT_ENUM.SMALL);
    const ariaId = useId();

    useEffect(() => {
        const handleResize = debounce(() => {
            setIsMobile(window.innerWidth <= BREAKPOINT_ENUM.SMALL);
        }, 200);

        if (isOpen) {
            window.addEventListener('resize', handleResize);
        } else {
            window.removeEventListener('resize', handleResize);
        };

        // set to correct size on initial load
        handleResize();
    }, [isOpen]);

    return (          
        <Modal aria-labelledby={`${ariaId}`} dialogClassName='responsive-modal no-padding-modal' style={{ animation: 'none' }} // turn off animation, otherwise you get a weird flicker when opening in full width
            size={isMobile === true ? 'full' : undefined}
            open={isOpen}
            onClose={onClose}
        >
            <label id={`${ariaId}`} className="sr-only">{ariaLabel}-modal</label>
            {children}
        </Modal>
    );
};

export default ResponsiveModal;